// React
import { create } from 'zustand';

// Other
import { deleteProfilePicture, getProfile, getProfilePicture, getProfileType, updateProfile, updateProfilePicture } from '../service/httpService/profile/index.js';

const useProfileStore = create((set, get) => ({
	//* Edit page
	openEditProfile: false,
	setOpenEditProfile: (openEditProfile) => set({ openEditProfile: openEditProfile }),
	
	//* Profile Data
	profile: null,
	setProfile: (profile) => set({ profile: profile }),

	userEmail: "",
	setUserEmail: (userEmail) => set({ userEmail: userEmail }),
	
	profilePicture: null,
	setProfilePicture: (profilePicture) => set({ profilePicture: profilePicture }),

	profilePictureDB: null,
	
	profileType: "",

	colorScheme: "",
	setColorScheme: (colorScheme) => set({ colorScheme: colorScheme }),

	//* Fetch Data
	fetchProfileData: async () => {
		const userEmail = get().userEmail;
		const resProfileType = await getProfileType(userEmail).catch(() => null);
		if(!resProfileType) {
			return;
 	 	}
		set({ profileType: resProfileType.data });

		const resProfile = await getProfile(userEmail).catch(() => null);
		if(!resProfile) {
			return;
		}
		set({ profile: resProfile.data });
		set({ colorScheme: resProfile.data.colorScheme });

		const resProfilePicture = await getProfilePicture(userEmail).catch(() => null);
		if(!resProfilePicture) {
			return;
		}
		set({ profilePicture: resProfilePicture.data.size ? resProfilePicture.data : undefined });

		set({ profilePictureDB: resProfilePicture.data.size ? resProfilePicture.data : undefined });
	},

	deleteProfilePicture: async () => {
		const response = await deleteProfilePicture(get().profile.email).catch(() => false);
		if(!response) {
			set({ profilePicture: undefined });
		}
		return response;
	},

	editProfile: async (setLoaded) => {
		const updateProfileResponse = await updateProfile(get().profile.email, get().profile).catch(() => false);
		
		if(!updateProfileResponse) {
			return { error: true, message: "Aktualisieren des Profils fehlgeschlagen!" };
		}

		if(!get().profilePicture) {
			const response = await deleteProfilePicture(get().profile.email).catch(() => false);
			if(!response) {
				set({ profilePicture: undefined });
			}
			return true;
		}

		let formData = new FormData();
		formData.append('picture', get().profilePicture, `${get().profile.lastName}_${get().profile.firstName}`);

		const pictureResponse = await updateProfilePicture(get().profile.email, formData, setLoaded).catch(() => false);
		if(!pictureResponse) {
			return { error: true, message: "Aktualisieren des Profilbildes fehlgeschlagen!" };
		}
		set({ profilePictureDB: get().profilePicture });
		
		return true;
	}
}));

export default useProfileStore;